import log from '$$log';
import GridColumns from './columns';
import GridRows from './rows';
import GridColumnsEditors from './editors';
import KeyboardNavigation from './keyboardNavigation';
import Dnd from './dnd';
import WebixContextMenu from './webixContextMenu';
import MassChangeContextMenu from './massChangeContextMenu';
import MassChangeSelectMenu from './massChangeSelectMenu';

export default {
  init(instance, projectConfig) {
    const tColumns = log.time('ganttConfigure.grid.columns');
    GridColumns.init(instance, projectConfig); // Initing grid columns and columns config (custom columns)
    tColumns.end();

    const tEditors = log.time('ganttConfigure.grid.editors');
    GridColumnsEditors.init(instance, projectConfig); // Initing editor types and attaching them to columns
    tEditors.end();

    const tRows = log.time('ganttConfigure.grid.rows');
    GridRows.init(instance); // Add custom row render and includes task click handler
    tRows.end();

    Dnd.init(instance);
    KeyboardNavigation.init(instance);
    WebixContextMenu.init(instance);
    MassChangeContextMenu.init(instance);
    MassChangeSelectMenu.init(instance);
  },

  initForExport(instance, projectConfig) {
    GridColumns.init(instance, projectConfig);
    GridRows.init(instance);
  },
};
